import List from "@/views/Textes/TextesList";
import SentenceBuilder from "@/pages/SentenceBuilder";
import Exercice from "@/views/Exercices/Exercice";
import Conjugaison from "@/pages/Conjugaison";
import {Storage} from "@/js/caller";
import DiscussionPage from "../pages/DiscussionPage";
import LeconPage from "@/pages/LeconPage";
import ExerciceEditor from "../views/Exercices/ExerciceEditor";
import ExerciceList from "../views/Exercices/ExerciceList";
import EleveView from "@/views/Eleves/EleveView";
import EleveList from "@/views/Eleves/EleveList";
import TextesRouter from "@/views/Textes/TextesVue";
import Landing from "@/views/Main/Landing";
import {Listener} from "@/lib/Listener";

const registre = {
  'Landing'         : {Component: Landing, Name: 'Landing'},
  'ListTexts'       : {Component: List, Name: 'ListTexts'},
  'EditorTexts'     : {Component: TextesRouter, name: 'EditorTexts'},
  'Sentence-Builder': {Component: SentenceBuilder, name: 'Sentence-Builder'},
  'Exercice'        : {Component: Exercice, name: 'Exercice'},
  'Conjugaison'     : {Component: Conjugaison, name: 'Conjugaison'},
  'Discussion'      : {Component: DiscussionPage, name: 'Discussion'},
  'Lecon'           : {Component: LeconPage, name: 'Lecon'},
  'ExerciceEditor'  : {Component: ExerciceEditor, name: 'ExerciceEditor'},
  'ExerciceList'    : {Component: ExerciceList, name: 'ExerciceList'},
  'EleveView'       : {Component: EleveView, name: 'EleveView'},
  'EleveList'       : {Component: EleveList, name: 'EleveList'},
  'default'         : {Component: List, Name: 'ListTexts'}
};
let current = 'default', vueParams = {};
// Persistence
const pKey = "persistence"
const persistance = Storage.Get(pKey) || {} // {[key:string]:any}
const historic = [];
//Callbacks
const event = "history"
const l = new Listener();

const History = {
  Register(component) {
    this.component = component;
  },
  GetComponent() {
    return (registre[current] || registre["default"]).Component
  },
  GetComponentName() {
    return (registre[current] || registre["default"]).Name
  },
  GoTo(key, params = {}, skip = false) {
    if (!skip) historic.push({key: current, params: vueParams});
    current = key
    vueParams = params
    l.Run(event)
    if (this.component) this.component.$forceUpdate()
  },
  GoBack() {
    const {key, params} = historic.pop();
    this.GoTo(key, params, true);
  },
  GetParams() {
    return Object.assign({}, vueParams)
  },
  Persistence: {
    Get() {
      return persistance[window.location.pathname]
    },
    Bind(component, expOrFn) {
      const key = window.location.pathname
      component.$watch(expOrFn, (newValue) => {
        persistance[key] = {
          ...persistance[key],
          [expOrFn]: newValue
        };
        Storage.Save(pKey, persistance)
      }, {deep: true});
    },
  },
  Listener   : {
    Subscribe  : l.Subscribe.bind(l, event),
    Unsubscribe: l.Unsubscribe.bind(l),
  }
}
export {History}